import { useCallback } from "react";
import { calculateDomesticServiceCost } from "../api/domestic-service/domestic-service-api";

export const domesticServiceCalculator = (
    requestCriteria, 
    serviceDate, 
    startTime,
    endTime, 
    setServicingCost, 
    setRateAggregatorFactor, 
    setServiceSummary, 
    setServiceType, 
    setHelperType, 
    setTotalDiscountPercent,
    setOriginalCost,
    setIsLoading,
    setErrorContent,
    setIsSystemError
) => {
    return useCallback(async () => {
        if (requestCriteria.length === 0 || !serviceDate || !startTime || !endTime) return;
        try {
            setIsLoading(true)
            const response = await calculateDomesticServiceCost(JSON.stringify(requestCriteria), serviceDate, startTime, endTime);
            setTotalDiscountPercent(response.discountPercent)
            setOriginalCost(response.serviceCost)
            const serviceCost = response.serviceCost - response.serviceCost * response.discountPercent / 100;
            // serviceCost = applyAdditionalDiscount(serviceCost);
            setServicingCost(serviceCost.toFixed(2));
            setServiceSummary(response.serviceSummary)
            // setTotalServices(response.totalServices)
            setServiceType(response.serviceType)

            if(response.helperType){
                setHelperType(response.helperType)
            }

            if (response.rateAggregatorFactor) {
                setRateAggregatorFactor(response.rateAggregatorFactor);
            } else {
                setRateAggregatorFactor("");
            }

            //get request for quote conversion
            try {
                if(typeof gtag != "undefined") {
                    gtag('event', 'conversion', { 'send_to': 'AW-823304067/8DScCLXxkpUZEIO_yogD' });
                }
            } catch (err) {
                console.log(err)
                setIsLoading(false)
                setErrorContent({'header': "Error calculating charges", 'body': "Please reload the app and try again. If problem persists, contact us at support@stringssg.com"});
                setIsSystemError(true)
            }
            setIsLoading(false)
        } catch (error) {
            console.log(error)
            setIsLoading(false)
            setErrorContent({'header': "Error calculating charges", 'body': "Please reload the app and try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true)
        }
    }, [requestCriteria, serviceDate, startTime, endTime, setServicingCost, setRateAggregatorFactor]);
}